import React from "react";
import Modal from "@mui/material/Modal";
import { Box, Button, CircularProgress, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const modalBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 440,
  maxWidth: "calc(100vw - 32px)",
  background: "#fff",
  borderRadius: "12px",
  outline: "none",
  overflow: "hidden",
  boxShadow: "0 24px 60px rgba(11, 35, 115, 0.22)",
};

export default function DeleteImageConfirmation({
  open,
  onClose,
  onConfirm,
  isDeleting = false,
}) {
  return (
    <Modal open={open} onClose={isDeleting ? undefined : onClose}>
      <Box sx={modalBoxStyle}>
        <Box
          sx={{
            background: "#126ABC",
            px: 2.5,
            py: 1.75,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: 16 }}>
            Delete Image
          </Typography>
          <IconButton
            onClick={onClose}
            sx={{ color: "#fff", p: 0.5 }}
            disabled={isDeleting}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ px: 3, py: 3.5, textAlign: "center" }}>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              background: "#FFF0F0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 2,
            }}
          >
            <DeleteOutlineIcon sx={{ fontSize: 32, color: "#D32F2F" }} />
          </Box>

          <Typography sx={{ fontWeight: 600, fontSize: 16, color: "#1a1a1a", mb: 1 }}>
            Are you sure?
          </Typography>
          <Typography sx={{ fontSize: 14, color: "#5a6a85", lineHeight: 1.6 }}>
            This image will be permanently removed from the product. This action cannot be undone.
          </Typography>
        </Box>

        <Box
          sx={{
            px: 3,
            py: 2,
            display: "flex",
            justifyContent: "flex-end",
            gap: 1.5,
            borderTop: "1px solid #e8eef5",
            background: "#f7fafd",
          }}
        >
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={isDeleting}
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              fontSize: 14,
              px: 3,
              height: 42,
              borderColor: "#c5d4e8",
              color: "#3d4f66",
              "&:hover": {
                borderColor: "#126ABC",
                background: "#f0f6fc",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            disabled={isDeleting}
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              fontSize: 14,
              px: 3,
              height: 42,
              background: "#D32F2F",
              boxShadow: "none",
              "&:hover": { background: "#B71C1C", boxShadow: "none" },
              "&.Mui-disabled": { background: "#e57373", color: "#fff" },
            }}
          >
            {isDeleting ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CircularProgress size={16} sx={{ color: "#fff" }} />
                Deleting...
              </Box>
            ) : (
              "Delete"
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
